module.exports = __webpack_public_path__ + "img/1.daa9dc76.jpg";